import styled from 'styled-components';
export var StyledTabPanels = styled.div.withConfig({
  displayName: "TabPanelsstyles__StyledTabPanels",
  componentId: "sc-1o6n6rq-0"
})(["flex:1;outline:none;"]);